import { CheckoutButton } from "@/components/CheckoutButton";
import { Reveal } from "@/components/Reveal";
import { PRECIO_MENSUAL } from "@/config";

export const CtaFinal = () => (
  <section className="relative overflow-hidden bg-[#070B16] px-5 py-24 md:py-32">
    <div
      className="pointer-events-none absolute -bottom-40 left-1/2 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-[#7C6CF0]/12 blur-[130px]"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-[1100px] text-center">
      <Reveal>
        <h2 className="mx-auto max-w-3xl font-[Fraunces] text-3xl font-semibold tracking-tight text-[#F5F1EA] md:text-5xl">
          No tienes que seguir procesándolo todo{" "}
          <span className="text-[#8B7CF6]">tú solo.</span>
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-[#9AA6BE] md:text-lg">
          Entra en un espacio donde puedes compartir lo que pasa por tu mente y
          encontrar a personas que también viven con intensidad, curiosidad y
          una sensación frecuente de ser diferentes.
        </p>
      </Reveal>

      <Reveal delay={0.2} className="mt-12 flex flex-col items-center">
        <CheckoutButton testId="cta-final-join" origen="cta_final">
          Quiero entrar — {PRECIO_MENSUAL} €/mes
        </CheckoutButton>
        <p className="mt-4 text-sm text-[#6B7690]">
          Acceso privado · Suscripción mensual · Sin permanencia
        </p>
      </Reveal>

      <Reveal delay={0.25}>
        <p
          data-testid="final-legal-disclaimer"
          className="mx-auto mt-16 max-w-2xl border-t border-white/10 pt-8 text-xs leading-relaxed text-[#6B7690]"
        >
          Esta comunidad es un espacio de conversación y apoyo entre personas
          con experiencias similares. No es terapia ni un servicio sanitario, y
          no sustituye la atención de profesionales de la salud.
        </p>
      </Reveal>
    </div>
  </section>
);
